<template>
  <div v-if="visible" class="download-progress-wrapper">
    <div class="download-progress-container">
      <div class="download-header">
        <div class="download-title">{{ title || '文件' }}下载中</div>
        <div class="download-close" @click="handleClose">×</div>
      </div>
      <div class="download-body">
        <el-progress
          :percentage="progress"
          :stroke-width="6"
          :color="colorConfig"
          class="download-progress-bar"
        >
          <template #default="{ percentage }">
            <span class="percentage-text">{{ percentage }}%</span>
          </template>
        </el-progress>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

// 定义props
const props = defineProps({
  progress: {
    type: Number,
    default: 0,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
})

// 定义事件
const emit = defineEmits(['close'])

// 颜色配置
const colorConfig = [
  { color: '#0770ED', percentage: 20 },
  { color: '#47CDF3', percentage: 100 },
]

// 关闭处理
const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.download-progress-wrapper {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  transition: all 0.3s ease;
}

.download-progress-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 300px;
  overflow: hidden;
}

.download-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.download-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;
}

.download-close {
  font-size: 18px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.download-close:hover {
  color: #666;
}

.download-body {
  padding: 12px 16px;
}

.download-progress-bar {
  margin: 0;
}

.percentage-text {
  font-size: 12px;
  color: #666;
}
</style>
